module.exports = __webpack_public_path__ + "img/41__535-220-low.d6d6b710.jpg";